import type { FileHandle } from '@/utils/fileHandler';
import { atom } from 'nanostores';

/**
 * Current file handle - bridges browser/tauri gap
 * Does not persist (file handles cannot be serialized)
 */
export const $currentFileHandle = atom<FileHandle | null>(null);
